// extracted by mini-css-extract-plugin
export var accessibilitySection = "style-module--accessibilitySection--NU1z9";
export var icons = "style-module--icons--hsxNs";
export var textSpan = "style-module--textSpan--ihdJ5";